class SizeGuideNav extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.els.trigger.elements.forEach(el =>
      this.listeners.add(
        el,
        'click',
        this.onPanelTriggerHandler.bind(this, event),
      ),
    )
  }

  onPanelTriggerHandler () {
    const triggerKey = Number(event.target.dataset.sizeGuideNavTriggerkey)

    this.externalEls.panel.elements.forEach((panel, index) => {
      if (triggerKey === index) {
        panel.setAttribute('aria-hidden', false)
      } else {
        panel.setAttribute('aria-hidden', true)
      }
    })

    event.currentTarget.setAttribute('aria-expanded', true)
    event.currentTarget.setAttribute('aria-disabled', true)

    this.els.trigger.elements.forEach((trigger, index) => {
      if (triggerKey !== index) {
        trigger.setAttribute('aria-expanded', false)
        trigger.setAttribute('aria-disabled', false)
      }
    })
  }
}

if (!customElements.get('size-guide-nav')) {
  customElements.define('size-guide-nav', SizeGuideNav)
}
